export default function PageHero({ label, title, subtitle, image, testid, children }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden bg-[#0F3A56] flex items-center min-h-[52vh]">
      {image ? (
        <>
          <img src={image} alt={title} className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F3A56]/95 via-[#0F3A56]/70 to-[#144F75]/30" />
        </>
      ) : (
        <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #fff 1px, transparent 1px)", backgroundSize: "28px 28px" }} />
      )}
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-24 w-full">
        {label && <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#D98E73] mb-4">{label}</p>}
        <h1 className="font-serif text-5xl md:text-6xl text-white tracking-tighter leading-[0.95] max-w-3xl eyw-reveal">
          {title}
        </h1>
        {subtitle && <p className="text-white/85 text-lg mt-6 max-w-2xl leading-relaxed">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
